import { api } from "./api";

export interface NotificationItem {
  id: number;
  template_key: string | null;
  category: string | null;
  severity: string | null;
  content: string | null;
  deep_link: string | null;
  athlete_id: number | null;
  read_at: string | null;
  snoozed_until: string | null;
  created_at: string;
}

export async function fetchNotifications(
  cursor?: number,
  category?: string,
  includeRead = false,
): Promise<NotificationItem[]> {
  const params: Record<string, string | number | boolean> = {};
  if (cursor) params.cursor = cursor;
  if (category) params.category = category;
  if (includeRead) params.include_read = true;
  const res = await api.get<NotificationItem[]>("/notifications", { params });
  return res.data;
}

/** Fired after any action that changes the unread count (read / snooze /
 * mark-all). The header badge listens and refetches immediately instead
 * of waiting for its 60s poll. */
export const NOTIF_CHANGED_EVENT = "storica:notif-changed";

export function emitNotifChanged(): void {
  window.dispatchEvent(new CustomEvent(NOTIF_CHANGED_EVENT));
}

export async function fetchUnreadCount(): Promise<number> {
  const res = await api.get<{ count: number }>("/notifications/count");
  return res.data.count;
}

export async function markRead(id: number): Promise<void> {
  await api.post(`/notifications/${id}/read`);
}

export async function snoozeNotification(id: number, duration: string): Promise<void> {
  await api.post(`/notifications/${id}/snooze`, { duration });
}

/** WAVE 5.A Inbox v2 — bulk mark-as-read.
 *
 * Marks every currently-active notification for this athlete as read.
 * Optional `category` filter so the user can wipe just one bucket.
 * Returns the number of rows updated server-side. */
export async function markAllRead(category?: string): Promise<number> {
  const params: Record<string, string> = {};
  if (category) params.category = category;
  const res = await api.post<{ ok: boolean; updated: number }>(
    "/notifications/mark-all-read",
    null,
    { params },
  );
  return res.data.updated;
}
